import { FormAddress, FormButton, FormGroup, FormTextRequire } from '@/components/Form'
import { ServiceType } from '@/constants'
import { useAuth, useCart, useStore } from '@/containers'
import type { GuestInfo, OrderService } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import { translateSchema } from '@/utils/validations'
import { Form, Formik } from 'formik'
import { sumBy } from 'lodash'
import { useTranslations } from 'next-intl'
import { useEffect, useState, type Dispatch, type SetStateAction } from 'react'
import DrawBottom from '../DrawBottom'
interface InformationType {
  listService: OrderService[]
  setListService: Dispatch<SetStateAction<OrderService[]>>
  productPrice: number
  priceAtWarehouse?: boolean
  productId: string
  receiveAtWarehouse: boolean
  pickUpInStore: boolean
  setPickUpInStore: Dispatch<SetStateAction<boolean>>
  preOrderPrice: number
  isPreOrder: boolean
  priceWithService: number
  setPriceWithService: Dispatch<SetStateAction<number>>
}
export const AccompaniedService = ({
  listService,
  setListService,
  productPrice,
  productId,
  receiveAtWarehouse,
  pickUpInStore,
  setPickUpInStore,
  preOrderPrice,
  isPreOrder = false,
  priceWithService,
  setPriceWithService
}: InformationType) => {
  const t = useTranslations('ProductDetail')
  const onChange = (e: OrderService) => {
    const chooseListService = listService.map(item => {
      if (item._id == e._id) {
        item.active = !item.active
      }
      return item
    })

    setListService(chooseListService)
  }
  const { selectedLang, provinces, setProvinceCode, setWardCode, wardDistricts, provinceCode, setDistrictCode } =
    useStore()
  const currency = (lang: string) => {
    switch (lang) {
      case 'vi':
        return 'VND'
      case 'en':
        return 'USD'
      default:
        return 'VND'
    }
  }
  useEffect(() => {
    const servicePrices = sumBy(
      listService.filter(e => e.active),
      'price'
    )
    if (isPreOrder) {
      return setPriceWithService(preOrderPrice + servicePrices)
    }
    return setPriceWithService(productPrice + servicePrices)
  }, [listService])

  const { chooseDestination, setGuestInfo, guestInfo } = useCart()
  const { setDestinationCode } = useAuth()

  const [isOpenDraw, setIsOpenDraw] = useState(false)

  const findMinPriceItem = (items: OrderService[]) => {
    if (items.length === 0) {
      return null
    }
    let minPriceItem = items[0]
    for (let i = 1; i < items.length; i++) {
      if (items[i].price < minPriceItem.price) {
        minPriceItem = items[i]
      }
    }
    return minPriceItem
  }
  const minPriceItem = findMinPriceItem(listService.filter(e => e.type == ServiceType.SHIPPING_AND_INSTALL))
  useEffect(() => {
    const addShippingAndInstall = listService.map(item => {
      if (minPriceItem && item._id == minPriceItem._id) {
        item.active = true
      }
      return item
    })
    setListService(addShippingAndInstall)
  }, [])

  const onChangeShippingAndInstall = (e: OrderService) => {
    const chooseShippingAndInstall = listService.map(item => {
      if (item._id == e._id) {
        item.active = true
      } else {
        if (item.type === ServiceType.SHIPPING_AND_INSTALL) {
          item.active = false
        }
      }
      return item
    })
    setPickUpInStore(false)
    setListService(chooseShippingAndInstall)
  }
  const handlePickUpInStore = (e: boolean) => {
    const clearShippingAndInstall = listService.map(item => {
      if (e && item.type === ServiceType.SHIPPING_AND_INSTALL) {
        item.active = false
      }
      return item
    })
    setListService(clearShippingAndInstall)
    setPickUpInStore(true)
  }
  useEffect(() => {
    if (guestInfo && guestInfo.provinceCode) {
      setProvinceCode(guestInfo.provinceCode)
    }
  }, [guestInfo])
  return (
    <>
      <div className='entry-price pt-2'>
        {listService && listService.length > 0 && (
          <div className='main-description break-words rounded-lg bg-white-200 px-2 py-1 pb-2'>
            {listService &&
              listService
                .filter(e => e.type == ServiceType.SHIPPING_AND_INSTALL)
                .map((e, i) => (
                  <div className='form-check-default form-check-shipping box-radio mt-2' key={i}>
                    <input
                      className='form-radio-input'
                      id={e?._id}
                      type='radio'
                      defaultChecked={minPriceItem?._id === e?._id}
                      name={ServiceType.SHIPPING_AND_INSTALL}
                      onClick={() => onChangeShippingAndInstall(e)}
                    />
                    <label className='form-radio-label flex flex-col' htmlFor={e?._id}>
                      <div className='w-full gap-x-2 leading-5'>
                        <span className='text-sm text-dark-900'>{getTranslate(e.name)}</span>
                        {e.price && e.price > 0 ? (
                          <>
                            <span className='text-sm font-bold text-primary-base'>
                              {' '}
                              {e.price
                                .toLocaleString(selectedLang as string, {
                                  style: 'currency',
                                  currency: currency(selectedLang as string)
                                })
                                .replace(/\s₫/g, 'đ')}
                            </span>
                          </>
                        ) : (
                          ''
                        )}
                      </div>
                      {getTranslate(e?.description) && (
                        <p className='text-xs italic leading-4 text-dark-900'>({getTranslate(e.description)})</p>
                      )}
                    </label>
                  </div>
                ))}
            {receiveAtWarehouse &&
              listService &&
              listService.filter(e => e.type == ServiceType.SHIPPING_AND_INSTALL).length > 0 && (
                <div className='form-check-default form-check-shipping box-radio mt-2'>
                  <input
                    className='form-radio-input'
                    id={'receiveAtWarehouse'}
                    type='radio'
                    name={ServiceType.SHIPPING_AND_INSTALL}
                    onClick={() => handlePickUpInStore(true)}
                  />
                  <label className='form-radio-label flex cursor-pointer flex-wrap' htmlFor={'receiveAtWarehouse'}>
                    <div className='w-full gap-x-2 leading-5'>
                      <span className='text-sm text-dark-900'>Nhận hàng tại kho</span>
                    </div>
                  </label>
                </div>
              )}
            {listService &&
              listService
                .filter(e => e.type !== ServiceType.SHIPPING_AND_INSTALL)
                .map((e, i) => (
                  <div className='form-check-default box-checkbox mt-1.5' key={i}>
                    <input
                      className='form-checkbox-input'
                      id={e?._id}
                      type='checkbox'
                      name={e?._id}
                      onClick={() => {
                        onChange(e)
                        if (e.type == ServiceType.SHIPPING && e.active) {
                          setIsOpenDraw(e.active || false)
                        }
                      }}
                    />
                    <label className='form-checkbox-label-sm flex flex-col' htmlFor={e?._id}>
                      <div className='w-full gap-x-2 leading-5'>
                        <span className='text-sm text-dark-900'>{getTranslate(e.name)}</span>
                        {e.price && e.price > 0 ? (
                          <>
                            <span className='text-sm font-bold text-primary-base'>
                              {' '}
                              {e.price
                                .toLocaleString(selectedLang as string, {
                                  style: 'currency',
                                  currency: currency(selectedLang as string)
                                })
                                .replace(/\s₫/g, 'đ')}
                            </span>
                          </>
                        ) : (
                          ''
                        )}
                        {e.type == ServiceType.SHIPPING && (
                          <span
                            className='cursor-pointer text-sm font-normal italic leading-normal text-blue-500'
                            onClick={() => setIsOpenDraw(!isOpenDraw)}
                          >
                            {' '}
                            (Chọn điểm giao hàng)
                          </span>
                        )}
                      </div>
                      {getTranslate(e?.description) && (
                        <span className='text-xs italic leading-4 text-dark-900'>({getTranslate(e.description)})</span>
                      )}
                    </label>
                  </div>
                ))}

            {(listService.filter(e => e.active).length > 0 || pickUpInStore) && (
              <>
                <div className='tempCalculate mt-3 border-t-2 border-white pt-2'>
                  <span className='font-medium text-dark-400'>{t('priceWithService')}:</span>{' '}
                  <span className='text-fieldInput font-bold text-primary-base'>
                    {priceWithService
                      .toLocaleString(selectedLang as string, {
                        style: 'currency',
                        currency: currency(selectedLang as string)
                      })
                      .replace(/\s₫/g, 'đ')}
                  </span>
                </div>
              </>
            )}
          </div>
        )}
      </div>
      <DrawBottom open={isOpenDraw} onClose={() => setIsOpenDraw(false)} title={'Chọn khu vực giao hàng'} scroll={true}>
        <div className='areaShipping flex h-full w-full content-between'>
          <Formik
            initialValues={{
              wardCode: guestInfo?.wardCode || '',
              provinceCode: guestInfo?.provinceCode || ''
            }}
            validationSchema={translateSchema('chooseDestination', t)}
            onSubmit={values => {
              chooseDestination(values.wardCode, productId).then(res => {
                const districtCode = wardDistricts.find(f => f.code === values.wardCode)?.parentCode as string
                setIsOpenDraw(false)
                setGuestInfo({
                  ...guestInfo,
                  wardCode: values.wardCode,
                  districtCode,
                  provinceCode
                } as GuestInfo)
                setDestinationCode(values.wardCode)
                setDistrictCode(districtCode)
                setListService(
                  listService.map(e => {
                    if (e.type === ServiceType.SHIPPING) {
                      e.price = res
                    }
                    return e
                  })
                )
              })
            }}
          >
            {props => (
              <Form className='w-full' onSubmit={props.handleSubmit}>
                <FormGroup className='mb-3 flex w-full flex-col'>
                  <FormAddress
                    placeholder={'Chọn Tỉnh/Thành Phố'}
                    title={'Chọn Tỉnh/Thành Phố'}
                    placeholderSearch={'Tìm nhanh tỉnh/thành Phố'}
                    onChange={e => {
                      setProvinceCode(e.target.value)
                      props.setFieldValue('provinceCode', e.target.value)
                    }}
                    value={props.values.provinceCode}
                    name='provinceCode'
                    classSelectButtonName={'bg-white-500 border border-gray text-center transition-all'}
                    data={provinces}
                  />
                  {props.errors.provinceCode ? (
                    <FormTextRequire className=' text-fieldInput text-sm font-normal text-primary-base'>
                      {props.errors.provinceCode as string}
                    </FormTextRequire>
                  ) : (
                    ''
                  )}
                </FormGroup>
                <FormGroup className='mb-3 flex w-full flex-col'>
                  <FormAddress
                    onChange={e => {
                      setWardCode(e.target.value || (guestInfo?.wardCode as string))
                      props.setFieldValue('wardCode', e.target.value || guestInfo?.wardCode)
                    }}
                    value={props.values.wardCode}
                    placeholder={'Chọn Quận/Huyện - Phường xã'}
                    title={'Chọn Quận/Huyện'}
                    placeholderSearch={'Tìm nhanh quận/huyện - phường/xã'}
                    name='wardCode'
                    classSelectButtonName={'rounded bg-white-500 border border-gray text-left transition-all'}
                    data={wardDistricts}
                  />
                  {props.errors.wardCode ? (
                    <FormTextRequire className=' text-fieldInput text-sm font-normal text-primary-base'>
                      {props.errors.wardCode as string}
                    </FormTextRequire>
                  ) : (
                    ''
                  )}
                </FormGroup>

                <div className='action mx-4 mt-[120px]'>
                  <FormButton
                    className={`bg-primary-baseh-[54px] w-full overflow-hidden rounded-[100px] text-fieldLabel font-bold text-white outline-none`}
                  >
                    Xác nhận
                  </FormButton>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </DrawBottom>
    </>
  )
}

export default AccompaniedService
